import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchPostBySlug, fetchAllPosts } from '../../services/blogService.js';
import Button from '../../components/ui/Button/Button.jsx';
import styles from './Article.module.css';

export default function Article() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [related, setRelated] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let active = true;
    setStatus('loading');
    Promise.all([fetchPostBySlug(slug), fetchAllPosts()]).then(([found, all]) => {
      if (!active) return;
      setPost(found);
      setRelated(all.filter((p) => p.slug !== slug).slice(0, 2));
      setStatus(found ? 'ready' : 'missing');
    });
    return () => { active = false; };
  }, [slug]);

  if (status === 'loading') {
    return <div className="container" style={{ paddingBlock: '4rem' }}>Loading article…</div>;
  }

  if (status === 'missing') {
    return (
      <div className={`container ${styles.missing}`}>
        <h1>Article not found</h1>
        <p>We couldn't find that story. It may have been moved or unpublished.</p>
        <Button to="/insights" variant="secondary">Back to Insights</Button>
      </div>
    );
  }

  return (
    <article className={styles.article}>
      <div className="container">
        <div className={styles.header}>
          <span className={styles.category}>{post.category}</span>
          <h1 className={styles.title}>{post.title}</h1>
          <div className={styles.byline}>
            <span className={styles.avatar} aria-hidden="true">{post.author.charAt(0)}</span>
            <div>
              <span className={styles.authorName}>{post.author}</span>
              <span className={styles.authorRole}>{post.authorRole} · {post.readTime}</span>
            </div>
          </div>
        </div>

        <div className={`${styles.cover} ${styles[`cover-${post.cover}`] ?? ''}`} />

        <div className={styles.body}>
          {post.content.map((block, i) =>
            block.type === 'h2' ? (
              <h2 key={i} className={styles.h2}>{block.text}</h2>
            ) : (
              <p key={i} className={styles.p}>{block.text}</p>
            )
          )}
        </div>

        {related.length > 0 && (
          <div className={styles.related}>
            <h3 className={styles.relatedTitle}>More from Insights</h3>
            <div className={styles.relatedGrid}>
              {related.map((r) => (
                <Link key={r.slug} to={`/insights/${r.slug}`} className={styles.relatedCard}>
                  <span className={styles.category}>{r.category}</span>
                  <span className={styles.relatedCardTitle}>{r.title}</span>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </article>
  );
}
